import React, { useEffect, useState } from 'react';
import api from '../../config/axios';
import Header from '../common/Header';
import { useNavigate } from 'react-router-dom';
import { useShop } from '../../contexts/ShopContext';
import './ShopSettings.css';

const ShopSettings: React.FC<{ user: any }> = ({ user }) => {
  const navigate = useNavigate();
  const { name, logoUrl, taxRate, refresh } = useShop();
  const [form, setForm] = useState({ name: '', logoUrl: '', taxRate: '0' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  // Đổ dữ liệu shop hiện tại vào form khi tải xong.
  useEffect(() => {
    setForm({ name: name || '', logoUrl: logoUrl || '', taxRate: String(taxRate ?? 0) });
  }, [name, logoUrl, taxRate]);

  const flash = (m: string, isErr = false) => {
    if (isErr) { setErr(m); setMsg(''); } else { setMsg(m); setErr(''); }
    setTimeout(() => { setMsg(''); setErr(''); }, 3000);
  };

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    const tax = Number(form.taxRate);
    if (isNaN(tax) || tax < 0 || tax > 100) return flash('Thuế suất phải từ 0 đến 100', true);
    setSaving(true);
    try {
      await api.patch('/api/shop/settings', {
        name: form.name.trim(),
        logoUrl: form.logoUrl.trim(),
        taxRate: tax,
      });
      await refresh();
      flash('Đã lưu cấu hình cửa hàng');
    } catch (e: any) {
      flash(e.response?.data?.message || 'Lỗi lưu cấu hình', true);
    } finally {
      setSaving(false);
    }
  };

  const onLogout = () => { localStorage.removeItem('token'); localStorage.removeItem('user'); window.location.href = '/'; };

  return (
    <>
      <Header user={user} onLogout={onLogout}>
        <span className="user-role">{user.role === 'admin' ? 'Quản lý' : 'Nhân viên'}</span>
      </Header>
      <div className="shop-settings-container">
        <div className="shop-settings-header">
          <button className="shop-settings-back" onClick={() => navigate('/')} title="Quay lại">←</button>
          <h2 className="shop-settings-title">CẤU HÌNH CỬA HÀNG</h2>
        </div>

        {msg && <div className="shop-settings-msg success">{msg}</div>}
        {err && <div className="shop-settings-msg error">{err}</div>}

        <form className="shop-settings-form" onSubmit={save}>
          <label>Tên cửa hàng</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Tên hiển thị" />

          <label>Logo (URL)</label>
          <input value={form.logoUrl} onChange={(e) => setForm({ ...form, logoUrl: e.target.value })} placeholder="https://.../logo.png" />

          <label>Thuế suất mặc định (%)</label>
          <input type="number" min={0} max={100} step="any" value={form.taxRate} onChange={(e) => setForm({ ...form, taxRate: e.target.value })} />
          <p className="shop-settings-hint">Mỗi món trong menu có thể đặt thuế suất riêng; món nào chưa đặt thì dùng mức mặc định này. Nhân viên không nhập thuế khi bán.</p>

          <button type="submit" className="shop-settings-save" disabled={saving}>
            {saving ? 'Đang lưu...' : 'Lưu cấu hình'}
          </button>
        </form>
      </div>
    </>
  );
};

export default ShopSettings;
